import React, { ReactNode } from "react"
import { FormControlLabel, Radio } from "@mui/material"
import styled from "styled-components"

export interface RadioButtonProps {
  name: string
  checked: boolean
  onChange: (value: boolean) => void
  label?: ReactNode
  disabled?: boolean
}

export const RadioButton = (props: RadioButtonProps) => {
  const { name, checked, onChange, label, disabled } = props

  return (
    <FormRadioLabel
      control={
        <Radio
          color="primary"
          disabled={disabled}
          value={checked}
          checked={checked}
          name={name}
          onChange={() => onChange(true)}
        />
      }
      label={label}
    />
  )
}

const FormRadioLabel = styled(FormControlLabel)`
  .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {
    padding-left: 7px;
  }
`
